export default __webpack_public_path__ + "static/media/Aviso de privacidade TokStok.51f016e5.pdf";